import { NewPaymentMethodsContainer } from './NewPaymentMethodsContainer';

export default NewPaymentMethodsContainer;
